import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { VehicleType } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';

const workorder: WorkOrder = {
  id: 1,
  number: 1,
  company: {
    id: 1,
    name: 'Ultracar Tecnologia e Informação LTDA',
    nickName: 'ULTRACAR',
  },
  customer: {
    id: 1,
    name: `Brian O'Conner`,
    cpfCnpj: '03675614336',
    birthDate: '1996-01-05',
    creditLimit: 10,
    enableLgpd: true,
    showLgpd: false,
    withheld: false,
    foreignDocument: null,
  },
  vehicle: {
    id: 1,
    licensePlate: 'GTRR340',
    model: 'Nissan Skyline',
    modelId: 2,
    brand: 'NISSAN',
    color: 'Cinza',
    chassi: '123456asd',
    fuelName: 'Gasolina',
    yearFabrication: 2010,
    yearModel: 2010,
    type: VehicleType.SUV,
    colorId: 1,
  },
  diagnosticId: undefined,
  complements: [
    {
      id: 50001177,
      complementIdentifier: '000123/00',
      status: WorkOrderComplementStatus.Authorized,
      number: 0,
    },
  ],
};

export default workorder;
